
import "../Foundation/stylable/shadows.st.css.js";
import "./AvatarCore/AvatarCore.st.css.js";
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/gradients.st.css.js";
import "../Foundation/stylable/typography.st.css.js";
import "../Foundation/stylable/easing.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_49_0_WSRAvatar";
var _style_ = /*#__PURE__*/ classesRuntime.bind(null, _namespace_);

export var cssStates = /*#__PURE__*/ statesRuntime.bind(null, _namespace_);
export var style = /*#__PURE__*/ _style_;
export var st = /*#__PURE__*/ _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_49_0_WSRAvatar__root","text-small-bold":"wds_1_49_0_StylableTypography__text-small-bold","text-tiny-normal":"wds_1_49_0_StylableTypography__text-tiny-normal","text-medium-normal":"wds_1_49_0_StylableTypography__text-medium-normal","text-medium-bold":"wds_1_49_0_StylableTypography__text-medium-bold","text-tiny-bold":"wds_1_49_0_StylableTypography__text-tiny-bold","heading-h6":"wds_1_49_0_StylableTypography__heading-h6","placeholder":"wds_1_49_0_WSRAvatar__placeholder","avatarContainer":"wds_1_49_0_WSRAvatar__avatarContainer","coreAvatar":"wds_1_49_0_WSRAvatar__coreAvatar","avatar":"wds_1_49_0_WSRAvatar__avatar","presence":"wds_1_49_0_WSRAvatar__presence","indication":"wds_1_49_0_WSRAvatar__indication","iconButtonShadow":"wds_1_49_0_WSRAvatar__iconButtonShadow","colorA1":"wds_1_49_0_WSRAvatar__colorA1","colorA2":"wds_1_49_0_WSRAvatar__colorA2","colorA3":"wds_1_49_0_WSRAvatar__colorA3","colorA4":"wds_1_49_0_WSRAvatar__colorA4","colorA5":"wds_1_49_0_WSRAvatar__colorA5","colorA6":"wds_1_49_0_WSRAvatar__colorA6","loaderContainer":"wds_1_49_0_WSRAvatar__loaderContainer","overlay":"wds_1_49_0_WSRAvatar__overlay","loader":"wds_1_49_0_WSRAvatar__loader"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




